import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
declare var createjs: any;
import { SessionService } from '../../../shared/services/session.service';

@Component({
  selector: 'app-yr3-st-ordattforsta-chapter6',
  templateUrl: './yr3-st-ordattforsta-chapter6.component.html',
  styleUrls: ['./yr3-st-ordattforsta-chapter6.component.scss']
})


export class Yr3StOrdattforstaChapter6Component implements OnInit {
  public bloburl: string;
  private stage: any;
  constructor(private sessionService: SessionService, public thisDialogRef: MatDialogRef<Yr3StOrdattforstaChapter6Component>, @Inject(MAT_DIALOG_DATA) public data: string) {

    this.bloburl = this.sessionService.bloburl;
  }

  ngOnInit() {

    var bloburl = this.sessionService.bloburl;

    var stage: any = new createjs.Stage("yr3_canvas");
    this.stage = stage;
    createjs.Touch.enable(stage);
    createjs.MotionGuidePlugin.install();

    var yr3_canvas: any = document.getElementById('yr3_canvas');
    yr3_canvas.width = 1785;
    yr3_canvas.height = 890;

    var yr3_bitmap = new createjs.Bitmap(bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/frame.png");
    yr3_bitmap.setTransform(0, 0, 0.992, 0.97);

    var yr3_heading = new createjs.Text("Ord att förstå", "bold 60px Dk-mariken", "#FF0000");
    yr3_heading.textAlign = "center";
    yr3_heading.setTransform(890, 80);

    var yr3_drake = new createjs.Bitmap(bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/drake.png");
    yr3_drake.setTransform(148, 615, 1, 1);

    var yr3_option_container = new createjs.Container();

    var yr3_tagimage1 = new createjs.Bitmap(bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/chapter6_tag.png");
    yr3_tagimage1.setTransform(42, 55);
    yr3_tagimage1.visible = true;

    var yr3_dashed_rect = new createjs.Shape();
    yr3_dashed_rect.graphics.setStrokeStyle(2).f('#FFFFFF').beginStroke("#ED8505").setStrokeDash([6, 6]).drawRoundRect(0, 0, 170, 78, 10);
    yr3_dashed_rect.setTransform(83, 180);

    var yr3_opt_text1 = new createjs.Text("Ord - bild", "17px MyriadPro-Regular", "#000000");
    yr3_opt_text1.setTransform(138, 196);

    var yr3_opt_text2 = new createjs.Text("Ord - text", "17px MyriadPro-Regular", "#000000");
    yr3_opt_text2.setTransform(138, 229);

    yr3_option_container.addChild(yr3_dashed_rect, yr3_opt_text1, yr3_opt_text2);

    var bagclose = new Image();
    bagclose.crossOrigin = "Anonymous";
    bagclose.src = bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/bag_close.png";

    var bagopen = new Image();
    bagopen.crossOrigin = "Anonymous";
    bagopen.src = bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/bag_open.png";

    var cheersound: any[string];
    cheersound = new Array(34);
    for (var i = 0; i < 34; i++) {
      cheersound[i] = new Audio();
      cheersound[i].src = bloburl + '/Lasresan/AK3/YR3-StudentsWeb/Tincan/cheerssound/audio' + i + '.mp3';
    }

    var yr3_opt_circle1: any = new createjs.Shape();
    yr3_opt_circle1.overColor = "#ED8505";
    yr3_opt_circle1.outColor = "#FFFFFF";
    yr3_opt_circle1.graphics.setStrokeStyle(2).beginFill(yr3_opt_circle1.overColor).beginStroke("#000000").drawCircle(0, 0, 11);
    yr3_opt_circle1.setTransform(115, 203);
    yr3_opt_circle1.cursor = 'pointer';
    yr3_opt_circle1.name = "ordbild";
    yr3_opt_circle1.addEventListener("click", function () {
      yr_ordbild(bloburl);
    });

    var yr3_opt_circle2: any = new createjs.Shape();
    yr3_opt_circle2.overColor = "#ED8505";
    yr3_opt_circle2.outColor = "#FFFFFF";
    yr3_opt_circle2.graphics.setStrokeStyle(2).beginFill(yr3_opt_circle2.outColor).beginStroke("#000000").drawCircle(0, 0, 11);
    yr3_opt_circle2.setTransform(115, 235);
    yr3_opt_circle2.cursor = 'pointer';
    yr3_opt_circle2.name = "ordtext";
    yr3_opt_circle2.addEventListener("click", function () {
      yr_ordtext();
    });

    yr_ordbild(bloburl);

    function shuffle(obj1, obj2) {
      var index = obj1.length;
      var rnd, tmp1, tmp2;

      while (index) {
        rnd = Math.floor(Math.random() * index);
        index -= 1;
        tmp1 = obj1[index];
        tmp2 = obj2[index];
        obj1[index] = obj1[rnd];
        obj2[index] = obj2[rnd];
        obj1[rnd] = tmp1;
        obj2[rnd] = tmp2;
      }
    }


    function yr_ordbild(bloburl) {

      for (var j = 0; j < stage.children.length; j++) {
        if (stage.children[j].name == "remove_ordbild" || stage.children[j].name == "remove_dragger" || stage.children[j].name == "remove_yr3_bag_close" ||
          stage.children[j].name == "removeimage1" || stage.children[j].name == "removeimage_2a" || stage.children[j].name == "remove_bagopen1"
          || stage.children[j].name == "removeimage_2") {
          stage.removeChild(stage.children[j]);
          j = j - 1;
        }
      }


      yr3_opt_circle1.graphics.clear().setStrokeStyle(1).beginFill(yr3_opt_circle1.overColor).beginStroke("#000000").drawCircle(0, 0, 11).endFill();
      yr3_opt_circle2.graphics.clear().setStrokeStyle(1).beginFill(yr3_opt_circle2.outColor).beginStroke("#000000").drawCircle(0, 0, 11).endFill();

      var cheersoundrandomNum = Math.floor((Math.random() * cheersound.length));

      var bag_close = new createjs.Bitmap(bagclose);
      bag_close.setTransform(1490, 678, 0.5, 0.5);
      bag_close.cursor = 'pointer';
      bag_close.visible = true;
      bag_close.name = "removeimage_2";

      var bag_open = new createjs.Bitmap(bagopen);
      bag_open.setTransform(1490, 622, 0.5, 0.5);
      bag_open.visible = false;
      bag_open.name = "remove_bagopen1";

      var yr3_quesimgrect = new createjs.Shape();
      yr3_quesimgrect.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").drawRoundRect(0, 0, 555, 372, 10);
      yr3_quesimgrect.setTransform(616, 200);
      yr3_quesimgrect.visible = true;
      yr3_quesimgrect.name = "removeimage_2";

      var sb: any = [0, 1, 2, 3, 4, 5, 6, 7];

      shuffle(sb, sb);

      var imgUrl: any[string];

      imgUrl = [bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/image1.png",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/image2.png",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/image3.png",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/image4.png",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/image5.png",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/image6.png",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/image7.png",
      bloburl + "/Lasresan/AK3/YR3-StudentsWeb/Tincan/ordattforsta/ordbildimages/Chapter6/image8.png"
      ];

      imgUrl.y = [282.5, 282.5, 282.5, 282.5, 282.5, 282.5, 282.5, 282.5];


      var yr3_questextarr: any[string];
      yr3_questextarr = ["Snön              hela taket.",
        "Marc              sig mellan ringarna.",
        "Kameleonten              sig på insekter.",
        "Linns händer är              av färg.",
        "Valhajen är en snäll och              jätte.",
        "På väggen hänger många olika             .",
        "Lejonet jagar sina             .",
        "Bävern är en              som gillar att fälla träd."
      ];

      var yr3_finaltextarr: any[string];
      yr3_finaltextarr = ["Snön täcker hela taket.",
        "Marc svingar sig mellan ringarna.",
        "Kameleonten livnär sig på insekter.",
        "Linns händer är klibbiga av färg.",
        "Valhajen är en snäll och fredlig jätte.",
        "På väggen hänger många olika verktyg.",
        "Lejonet jagar sina byten.",
        "Bävern är en gnagare som gillar att fälla träd."];

      var QuesTxt1_twowords = ["täcker", "svingar", "livnär", "klibbiga", "fredlig", "verktyg", "byten", "gnagare"];

      //dragger y position and timing array
      var draggershuffle1: any = [120, 180, 240, 300, 360, 420, 480, 540];
      let yr3_tweentimingarr: any = [0, 500, 1000, 1500, 2000, 2500, 3000, 3500];

      shuffle(draggershuffle1, yr3_tweentimingarr);

      var yr3_exercisecount = -1;

      bag_close.addEventListener("click", function () {

        for (var j = 0; j < stage.children.length; j++) {
          if (stage.children[j].name == "removeimage1") {
            stage.removeChild(stage.children[j]);
            j = j - 1;
          }
        }

        bag_close.visible = false;
        bag_open.visible = true;


        yr3_exercisecount += 1;

        var yr3_backimagecontainer = new createjs.Container();
        var yr3_backimage = new createjs.Bitmap(imgUrl[sb[yr3_exercisecount]]);
        var maskShape1 = new createjs.Shape(new createjs.Graphics().f("#000").drawRoundRectComplex(0, 0, 550, 367, 10, 10, 10, 10));
        yr3_backimage.mask = maskShape1;
        yr3_backimagecontainer.addChild(yr3_backimage);
        yr3_backimagecontainer.setTransform(618.5, 202.5);
        yr3_backimagecontainer.name = "removeimage1";

        var yr3_questext1: any = new createjs.Text(yr3_questextarr[sb[yr3_exercisecount]], "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_questext1_pos = yr3_questext1.getBounds();
        yr3_questext1.setTransform(((238 + 656) - yr3_questext1_pos.width / 2), 660);
        yr3_questext1.textBaseline = "alphabetic";
        yr3_questext1.alpha = 1;
        yr3_questext1.name = "removeimage1";

        var yr3_finaltext1: any = new createjs.Text(yr3_finaltextarr[sb[yr3_exercisecount]], "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_finaltext1_pos = yr3_finaltext1.getBounds();
        yr3_finaltext1.setTransform(((238 + 656) - yr3_finaltext1_pos.width / 2), 660);
        yr3_finaltext1.textBaseline = "alphabetic";
        yr3_finaltext1.alpha = 0;
        yr3_finaltext1.name = "removeimage1";


        //automatic calculation of the destination box position

        var consttext1_ex: any = new createjs.Text("Snön", "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_consttext1_ex_pos = consttext1_ex.getBounds();
        var temp_x1 = yr3_questext1.x + yr3_consttext1_ex_pos.width + 20;

        var consttext2_ex: any = new createjs.Text("Marc", "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_consttext2_ex_pos = consttext2_ex.getBounds();
        var temp_x2 = yr3_questext1.x + yr3_consttext2_ex_pos.width + 20;

        var consttext3_ex: any = new createjs.Text("Kameleonten", "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_consttext3_ex_pos = consttext3_ex.getBounds();
        var temp_x3 = yr3_questext1.x + yr3_consttext3_ex_pos.width + 20;

        var consttext4_ex: any = new createjs.Text("Linns händer är", "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_consttext4_ex_pos = consttext4_ex.getBounds();
        var temp_x4 = yr3_questext1.x + yr3_consttext4_ex_pos.width + 20;

        var consttext5_ex: any = new createjs.Text("Valhajen är en snäll och", "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_consttext5_ex_pos = consttext5_ex.getBounds();
        var temp_x5 = yr3_questext1.x + yr3_consttext5_ex_pos.width + 20;

        var consttext6_ex: any = new createjs.Text("På väggen hänger många olika", "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_consttext6_ex_pos = consttext6_ex.getBounds();
        var temp_x6 = yr3_questext1.x + yr3_consttext6_ex_pos.width + 18;

        var consttext7_ex: any = new createjs.Text("Lejonet jagar sina", "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_consttext7_ex_pos = consttext7_ex.getBounds();
        var temp_x7 = yr3_questext1.x + yr3_consttext7_ex_pos.width + 18;

        var consttext8_ex: any = new createjs.Text("Bävern är en", "65px MajemaSkol_Exercise_bold", "#696969");
        var yr3_consttext8_ex_pos = consttext8_ex.getBounds();
        var temp_x8 = yr3_questext1.x + yr3_consttext8_ex_pos.width + 20;


        //destination positions

        var destination1: any = new createjs.Shape();
        destination1.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 180, 40);
        destination1.setTransform(temp_x1, 631);
        destination1.alpha = 0;
        destination1.name = "removeimage1";

        var destination2: any = new createjs.Shape();
        destination2.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 180, 40);
        destination2.setTransform(temp_x2, 631);
        destination2.alpha = 0;
        destination2.name = "removeimage1";

        var destination3: any = new createjs.Shape();
        destination3.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 180, 40);
        destination3.setTransform(temp_x3, 631);
        destination3.alpha = 0;
        destination3.name = "removeimage1";

        var destination4: any = new createjs.Shape();
        destination4.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 180, 40);
        destination4.setTransform(temp_x4, 631);
        destination4.alpha = 0;
        destination4.name = "removeimage1";

        var destination5: any = new createjs.Shape();
        destination5.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 180, 40);
        destination5.setTransform(temp_x5, 631);
        destination5.alpha = 0;
        destination5.name = "removeimage1";

        var destination6: any = new createjs.Shape();
        destination6.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 180, 40);
        destination6.setTransform(temp_x6, 631);
        destination6.alpha = 0;
        destination6.name = "removeimage1";

        var destination7: any = new createjs.Shape();
        destination7.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 180, 40);
        destination7.setTransform(temp_x7, 631);
        destination7.alpha = 0;
        destination7.name = "removeimage1";

        var destination8: any = new createjs.Shape();
        destination8.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 180, 40);
        destination8.setTransform(temp_x8, 631);
        destination8.alpha = 0;
        destination8.name = "removeimage1";

        var destination_array: any = [destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination8];
        var destination_sbX: any = [temp_x1, temp_x2, temp_x3, temp_x4, temp_x5, temp_x6, temp_x7, temp_x8];
        destination_array[sb[yr3_exercisecount]].alpha = 1;
        destination_array[sb[yr3_exercisecount]].setBounds(destination_sbX[sb[yr3_exercisecount]], 631, 180, 10);

        var dynamic_ques1: any = new createjs.Text(QuesTxt1_twowords[0], "65px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 60);
        dynamic_ques1.textBaseline = "alphabetic";

        var dynamic_ques2: any = new createjs.Text(QuesTxt1_twowords[1], "65px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques2.setTransform(0, 60);
        dynamic_ques2.textBaseline = "alphabetic";

        var dynamic_ques3: any = new createjs.Text(QuesTxt1_twowords[2], "65px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques3.setTransform(0, 60);
        dynamic_ques3.textBaseline = "alphabetic";

        var dynamic_ques4: any = new createjs.Text(QuesTxt1_twowords[3], "65px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques4.setTransform(0, 60);
        dynamic_ques4.textBaseline = "alphabetic";

        var dynamic_ques5: any = new createjs.Text(QuesTxt1_twowords[4], "65px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques5.setTransform(0, 60);
        dynamic_ques5.textBaseline = "alphabetic";

        var dynamic_ques6: any = new createjs.Text(QuesTxt1_twowords[5], "65px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques6.setTransform(0, 60);
        dynamic_ques6.textBaseline = "alphabetic";

        var dynamic_ques7: any = new createjs.Text(QuesTxt1_twowords[6], "65px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques7.setTransform(0, 60);
        dynamic_ques7.textBaseline = "alphabetic";

        var dynamic_ques8: any = new createjs.Text(QuesTxt1_twowords[7], "65px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques8.setTransform(0, 60);
        dynamic_ques8.textBaseline = "alphabetic";


        var g1 = dynamic_ques1.getBounds();
        var g2 = dynamic_ques2.getBounds();
        var g3 = dynamic_ques3.getBounds();
        var g4 = dynamic_ques4.getBounds();
        var g5 = dynamic_ques5.getBounds();
        var g6 = dynamic_ques6.getBounds();
        var g7 = dynamic_ques7.getBounds();
        var g8 = dynamic_ques8.getBounds();


        var dragger1: any = new createjs.Container();
        dragger1.cursor = 'pointer';
        dragger1.name = "removeimage1";
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 26, g1.width, 49);
        rect1.alpha = 1;
        stage.enableMouseOver(20);
        dragger1.addChild(rect1, dynamic_ques1);
        dragger1.setTransform(1200, draggershuffle1[0]);
        dragger1.alpha = 0;
        dragger1.on("pressmove", pressmovedragger);
        dragger1.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 0, 0);
        });

        var dragger2: any = new createjs.Container();
        dragger2.cursor = 'pointer';
        dragger2.name = "removeimage1";
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 26, g2.width, 49);
        rect1.alpha = 1;
        stage.enableMouseOver(20);
        dragger2.addChild(rect1, dynamic_ques2);
        dragger2.setTransform(1200, draggershuffle1[1]);
        dragger2.alpha = 0;
        dragger2.on("pressmove", pressmovedragger);
        dragger2.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 1, 1);
        });

        var dragger3: any = new createjs.Container();
        dragger3.cursor = 'pointer';
        dragger3.name = "removeimage1";
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 26, g3.width, 49);
        rect1.alpha = 1;
        stage.enableMouseOver(20);
        dragger3.addChild(rect1, dynamic_ques3);
        dragger3.setTransform(1200, draggershuffle1[2]);
        dragger3.alpha = 0;
        dragger3.on("pressmove", pressmovedragger);
        dragger3.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 2, 2);
        });

        var dragger4: any = new createjs.Container();
        dragger4.cursor = 'pointer';
        dragger4.name = "removeimage1";
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 26, g4.width, 49);
        rect1.alpha = 1;
        stage.enableMouseOver(20);
        dragger4.addChild(rect1, dynamic_ques4);
        dragger4.setTransform(1200, draggershuffle1[3]);
        dragger4.alpha = 0;
        dragger4.on("pressmove", pressmovedragger);
        dragger4.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 3, 3);
        });

        var dragger5: any = new createjs.Container();
        dragger5.cursor = 'pointer';
        dragger5.name = "removeimage1";
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 26, g5.width, 49);
        rect1.alpha = 1;
        stage.enableMouseOver(20);
        dragger5.addChild(rect1, dynamic_ques5);
        dragger5.setTransform(1200, draggershuffle1[4]);
        dragger5.alpha = 0;
        dragger5.on("pressmove", pressmovedragger);
        dragger5.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 4, 4);
        });

        var dragger6: any = new createjs.Container();
        dragger6.cursor = 'pointer';
        dragger6.name = "removeimage1";
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 26, g6.width, 49);
        rect1.alpha = 1;
        stage.enableMouseOver(20);
        dragger6.addChild(rect1, dynamic_ques6);
        dragger6.setTransform(1200, draggershuffle1[5]);
        dragger6.alpha = 0;
        dragger6.on("pressmove", pressmovedragger);
        dragger6.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 5, 5);
        });

        var dragger7: any = new createjs.Container();
        dragger7.cursor = 'pointer';
        dragger7.name = "removeimage1";
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 26, g7.width, 49);
        rect1.alpha = 1;
        stage.enableMouseOver(20);
        dragger7.addChild(rect1, dynamic_ques7);
        dragger7.setTransform(1200, draggershuffle1[6]);
        dragger7.alpha = 0;
        dragger7.on("pressmove", pressmovedragger);
        dragger7.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 6, 6);
        });


        var dragger8: any = new createjs.Container();
        dragger8.cursor = 'pointer';
        dragger8.name = "removeimage1";
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 26, g8.width, 49);
        rect1.alpha = 1;
        stage.enableMouseOver(20);
        dragger8.addChild(rect1, dynamic_ques8);
        dragger8.setTransform(1200, draggershuffle1[7]);
        dragger8.alpha = 0;
        dragger8.on("pressmove", pressmovedragger);
        dragger8.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 7, 7);
        });

        var bag_closefinal = new createjs.Bitmap(bagclose);
        bag_closefinal.setTransform(1490, 678, 0.5, 0.5);
        bag_closefinal.visible = false;
        bag_closefinal.name = "removeimage_2a";
        stage.addChild(bag_closefinal);

        let draggerarray: any = [dragger1, dragger2, dragger3, dragger4, dragger5, dragger6, dragger7, dragger8];


        var tween1: any = createjs.Tween.get(dragger1, { paused: false }).wait(yr3_tweentimingarr[0]).to({ alpha: 0, x: 1540, y: 680 }, 0).to({ alpha: 1, x: 1200, y: draggershuffle1[0], mouseEnabled: false }, 500);
        var tween2: any = createjs.Tween.get(dragger2, { paused: false }).wait(yr3_tweentimingarr[1]).to({ alpha: 0, x: 1540, y: 680 }, 0).to({ alpha: 1, x: 1200, y: draggershuffle1[1], mouseEnabled: false }, 500);
        var tween3: any = createjs.Tween.get(dragger3, { paused: false }).wait(yr3_tweentimingarr[2]).to({ alpha: 0, x: 1540, y: 680 }, 0).to({ alpha: 1, x: 1200, y: draggershuffle1[2], mouseEnabled: false }, 500);
        var tween4: any = createjs.Tween.get(dragger4, { paused: false }).wait(yr3_tweentimingarr[3]).to({ alpha: 0, x: 1540, y: 680 }, 0).to({ alpha: 1, x: 1200, y: draggershuffle1[3], mouseEnabled: false }, 500);
        var tween5: any = createjs.Tween.get(dragger5, { paused: false }).wait(yr3_tweentimingarr[4]).to({ alpha: 0, x: 1540, y: 680 }, 0).to({ alpha: 1, x: 1200, y: draggershuffle1[4], mouseEnabled: false }, 500);
        var tween6: any = createjs.Tween.get(dragger6, { paused: false }).wait(yr3_tweentimingarr[5]).to({ alpha: 0, x: 1540, y: 680 }, 0).to({ alpha: 1, x: 1200, y: draggershuffle1[5], mouseEnabled: false }, 500);
        var tween7: any = createjs.Tween.get(dragger7, { paused: false }).wait(yr3_tweentimingarr[6]).to({ alpha: 0, x: 1540, y: 680 }, 0).to({ alpha: 1, x: 1200, y: draggershuffle1[6], mouseEnabled: false }, 500);
        var tween8: any = createjs.Tween.get(dragger8, { paused: false }).wait(yr3_tweentimingarr[7]).to({ alpha: 0, x: 1540, y: 680 }, 0).to({ alpha: 1, x: 1200, y: draggershuffle1[7], mouseEnabled: false }, 500);

        var tween9: any = createjs.Tween.get(bag_closefinal, { paused: false }).wait(4500).to({ visible: true }, 0);

        var tween10: any = createjs.Tween.get(bag_open, { paused: false }).wait(4500).call(function () {

          draggerarray[0].mouseEnabled = true;
          draggerarray[1].mouseEnabled = true;
          draggerarray[2].mouseEnabled = true;
          draggerarray[3].mouseEnabled = true;
          draggerarray[4].mouseEnabled = true;
          draggerarray[5].mouseEnabled = true;
          draggerarray[6].mouseEnabled = true;
          draggerarray[7].mouseEnabled = true;

        }).to({ visible: false }, 0);

        stage.addChild(yr3_backimagecontainer, yr3_questext1, yr3_finaltext1,
          destination1, destination2, destination3, destination4, destination5, destination6, destination7, destination8,
          dragger1, dragger2, dragger3, dragger4, dragger5, dragger6, dragger7, dragger8);



        var settrasformarrayx: any = [1200, 1200, 1200, 1200, 1200, 1200, 1200, 1200];

        var settrasformarrayy: any = [draggershuffle1[0], draggershuffle1[1], draggershuffle1[2], draggershuffle1[3], draggershuffle1[4], draggershuffle1[5], draggershuffle1[6], draggershuffle1[7]];


        function pressmovedragger(evt: any) {

          evt.currentTarget.x = evt.stageX - 50;
          evt.currentTarget.y = evt.stageY - 50;


        }

        function pressmovedraggerleave(evt: any, j: any, i: any) {

          if (intersect(draggerarray[sb[yr3_exercisecount]], destination_array[sb[yr3_exercisecount]])) {
            var yr3_draggerbounds1 = draggerarray[sb[yr3_exercisecount]].getBounds();
            draggerarray[sb[yr3_exercisecount]].x = destination_array[sb[yr3_exercisecount]].x + (180 - yr3_draggerbounds1.width) / 2;;
            draggerarray[sb[yr3_exercisecount]].y = destination_array[sb[yr3_exercisecount]].y - 30;
            //remove the temporary dragger, question, destination box and add final text
            createjs.Tween.get(destination_array[sb[yr3_exercisecount]]).wait(500).to({ alpha: 0 }, 500);
            createjs.Tween.get(draggerarray[sb[yr3_exercisecount]].children[0]).wait(1000).to({ alpha: 0 }, 500);
            createjs.Tween.get(draggerarray[sb[yr3_exercisecount]]).wait(1500).to({ alpha: 0 }, 500);
            createjs.Tween.get(yr3_questext1).wait(1500).to({ alpha: 0 }, 500);
            createjs.Tween.get(yr3_finaltext1).wait(2000).to({ alpha: 1 }, 500);

            draggerarray[sb[yr3_exercisecount]].name = "removeimage1";

            draggerarray[0].mouseEnabled = false;
            draggerarray[1].mouseEnabled = false;
            draggerarray[2].mouseEnabled = false;
            draggerarray[3].mouseEnabled = false;
            draggerarray[4].mouseEnabled = false;
            draggerarray[5].mouseEnabled = false;
            draggerarray[6].mouseEnabled = false;
            draggerarray[7].mouseEnabled = false;

            if (yr3_exercisecount == 7) {
              bag_closefinal.visible = true;
              bag_close.visible = false;
              cheersound[cheersoundrandomNum].play();
            } else {
              bag_closefinal.visible = false;
              bag_close.visible = true;
            }


          }
          else {
            createjs.Tween.get(draggerarray[j])
              .to({ x: settrasformarrayx[j], y: settrasformarrayy[j] }, 500);

          }
        }



        if (yr3_exercisecount == 1 || yr3_exercisecount == 2 || yr3_exercisecount == 3 || yr3_exercisecount == 4 || yr3_exercisecount == 5 || yr3_exercisecount == 6 || yr3_exercisecount == 7) {

          tween1.paused = true;
          tween1.setPaused(true);
          tween2.paused = true;
          tween2.setPaused(true);
          tween3.paused = true;
          tween3.setPaused(true);
          tween4.paused = true;
          tween4.setPaused(true);
          tween5.paused = true;
          tween5.setPaused(true);
          tween6.paused = true;
          tween6.setPaused(true);
          tween7.paused = true;
          tween7.setPaused(true);
          tween8.paused = true;
          tween8.setPaused(true);
          tween9.paused = true;
          tween9.setPaused(true);
          tween10.paused = true;
          tween10.setPaused(true);

          createjs.Tween.get(bag_closefinal, { paused: false }).wait(500).to({ visible: true }, 0);
          createjs.Tween.get(bag_open, { paused: false }).wait(500).to({ visible: false }, 0);

          dragger1.alpha = 1;
          dragger2.alpha = 1;
          dragger3.alpha = 1;
          dragger4.alpha = 1;
          dragger5.alpha = 1;
          dragger6.alpha = 1;
          dragger7.alpha = 1;
          dragger8.alpha = 1;
        }

        if (yr3_exercisecount == 1) {
          draggerarray[sb[yr3_exercisecount - 1]].alpha = 0;
        }

        if (yr3_exercisecount == 2) {
          draggerarray[sb[yr3_exercisecount - 1]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 2]].alpha = 0;
        }

        if (yr3_exercisecount == 3) {
          draggerarray[sb[yr3_exercisecount - 1]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 2]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 3]].alpha = 0;
        }

        if (yr3_exercisecount == 4) {
          draggerarray[sb[yr3_exercisecount - 1]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 2]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 3]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 4]].alpha = 0;
        }

        if (yr3_exercisecount == 5) {
          draggerarray[sb[yr3_exercisecount - 1]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 2]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 3]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 4]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 5]].alpha = 0;
        }

        if (yr3_exercisecount == 6) {
          draggerarray[sb[yr3_exercisecount - 1]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 2]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 3]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 4]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 5]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 6]].alpha = 0;
        }

        if (yr3_exercisecount == 7) {
          draggerarray[sb[yr3_exercisecount - 1]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 2]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 3]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 4]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 5]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 6]].alpha = 0;
          draggerarray[sb[yr3_exercisecount - 7]].alpha = 0;
          bag_close.visible = false;
          bag_open.visible = false;
          bag_closefinal.visible = true;
          bag_closefinal.alpha = 0.5;
        }

      });

      stage.addChild(yr3_quesimgrect, bag_close, bag_open);

    }


    function yr_ordtext() {

      yr3_opt_circle1.graphics.clear().setStrokeStyle(1).beginFill(yr3_opt_circle1.outColor).beginStroke("#000000").drawCircle(0, 0, 11).endFill();
      yr3_opt_circle2.graphics.clear().setStrokeStyle(1).beginFill(yr3_opt_circle2.overColor).beginStroke("#000000").drawCircle(0, 0, 11).endFill();


      for (var j = 0; j < stage.children.length; j++) {
        if (stage.children[j].name == "removeimage1" || stage.children[j].name == "removeimage_2" || stage.children[j].name == "removeimage_2a" || stage.children[j].name == "remove_ordbild" || stage.children[j].name == "remove_dragger" || stage.children[j].name == "remove_bagopen1") {
          stage.removeChild(stage.children[j]);
          j = j - 1;
        }
      }
      var cheersoundrandomNum = Math.floor((Math.random() * cheersound.length));

      var yr3_bag_open = new createjs.Bitmap(bagopen);
      yr3_bag_open.setTransform(1490, 622, 0.5, 0.5);
      yr3_bag_open.visible = false;
      yr3_bag_open.name = "remove_bagopen1";

      //automatic calculation of destination box position X

      var consttext1: any = new createjs.Text("Färgen vi målar med", "55px MajemaSkol_Exercise_bold", "#696969");
      var yr3_consttext1_pos = consttext1.getBounds();

      var consttext2: any = new createjs.Text("Aporna", "55px MajemaSkol_Exercise_bold", "#696969");
      var yr3_consttext2_pos = consttext2.getBounds();

      var consttext3: any = new createjs.Text("Min lillebror", "55px MajemaSkol_Exercise_bold", "#696969");
      var yr3_consttext3_pos = consttext3.getBounds();

      var consttext4: any = new createjs.Text("De nymålade stolarna var alldeles", "55px MajemaSkol_Exercise_bold", "#696969");
      var yr3_consttext4_pos = consttext4.getBounds();

      var consttext5: any = new createjs.Text("Skorpionen är inte särskilt", "55px MajemaSkol_Exercise_bold", "#696969");
      var yr3_consttext5_pos = consttext5.getBounds();

      var consttext6: any = new createjs.Text("Hammaren är det", "55px MajemaSkol_Exercise_bold", "#696969");
      var yr3_consttext6_pos = consttext6.getBounds();

      var consttext7: any = new createjs.Text("Katten hade lagt sina", "55px MajemaSkol_Exercise_bold", "#696969");
      var yr3_consttext7_pos = consttext7.getBounds();

      var consttext8: any = new createjs.Text("Man kan känna igen", "55px MajemaSkol_Exercise_bold", "#696969");
      var yr3_consttext8_pos = consttext8.getBounds();


      var yr3_destination1: any = new createjs.Shape();
      yr3_destination1.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 150, 40);
      yr3_destination1.setTransform(300 + yr3_consttext1_pos.width + 17, 200);
      yr3_destination1.setBounds(300 + yr3_consttext1_pos.width + 17, 200, 150, 10);
      yr3_destination1.name = "remove_ordbild";

      var yr3_destination2: any = new createjs.Shape();
      yr3_destination2.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 150, 40);
      yr3_destination2.setTransform(300 + yr3_consttext2_pos.width + 17, 270);
      yr3_destination2.setBounds(300 + yr3_consttext2_pos.width + 17, 270, 150, 10);
      yr3_destination2.name = "remove_ordbild";

      var yr3_destination3: any = new createjs.Shape();
      yr3_destination3.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 150, 40);
      yr3_destination3.setTransform(300 + yr3_consttext3_pos.width + 17, 340);
      yr3_destination3.setBounds(300 + yr3_consttext3_pos.width + 17, 340, 150, 10);
      yr3_destination3.name = "remove_ordbild";

      var yr3_destination4: any = new createjs.Shape();
      yr3_destination4.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 150, 40);
      yr3_destination4.setTransform(300 + yr3_consttext4_pos.width + 17, 410);
      yr3_destination4.setBounds(300 + yr3_consttext4_pos.width + 17, 410, 150, 10);
      yr3_destination4.name = "remove_ordbild";

      var yr3_destination5: any = new createjs.Shape();
      yr3_destination5.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 150, 40);
      yr3_destination5.setTransform(300 + yr3_consttext5_pos.width + 17, 480);
      yr3_destination5.setBounds(300 + yr3_consttext5_pos.width + 17, 480, 150, 10);
      yr3_destination5.name = "remove_ordbild";

      var yr3_destination6: any = new createjs.Shape();
      yr3_destination6.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 150, 40);
      yr3_destination6.setTransform(300 + yr3_consttext6_pos.width + 17, 550);
      yr3_destination6.setBounds(300 + yr3_consttext6_pos.width + 17, 550, 150, 10);
      yr3_destination6.name = "remove_ordbild";

      var yr3_destination7: any = new createjs.Shape();
      yr3_destination7.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 150, 40);
      yr3_destination7.setTransform(300 + yr3_consttext7_pos.width + 17, 620);
      yr3_destination7.setBounds(300 + yr3_consttext7_pos.width + 17, 620, 150, 10);
      yr3_destination7.name = "remove_ordbild";

      var yr3_destination8: any = new createjs.Shape();
      yr3_destination8.graphics.setStrokeStyle(2).f("#FFFFFF").beginStroke("#ED8505").setStrokeDash([6, 6]).drawRect(0, 0, 150, 40);
      yr3_destination8.setTransform(300 + yr3_consttext8_pos.width + 17, 690);
      yr3_destination8.setBounds(300 + yr3_consttext8_pos.width + 17, 690, 150, 10);
      yr3_destination8.name = "remove_ordbild";


      var yr3_filltext1: any = new createjs.Text("Färgen vi målar med              bra.", "55px MajemaSkol_Exercise_bold", "#696969");
      yr3_filltext1.setTransform(300, 230);
      yr3_filltext1.textBaseline = "alphabetic";
      yr3_filltext1.name = "remove_ordbild";

      var yr3_filltext2: any = new createjs.Text("Aporna              sig fram bland grenar och lianer.", "55px MajemaSkol_Exercise_bold", "#696969");
      yr3_filltext2.setTransform(300, 300);
      yr3_filltext2.textBaseline = "alphabetic";
      yr3_filltext2.name = "remove_ordbild";

      var yr3_filltext3: any = new createjs.Text("Min lillebror              sig på välling.", "55px MajemaSkol_Exercise_bold", "#696969");
      yr3_filltext3.setTransform(300, 370);
      yr3_filltext3.textBaseline = "alphabetic";
      yr3_filltext3.name = "remove_ordbild";

      var yr3_filltext4: any = new createjs.Text("De nymålade stolarna var alldeles             .", "55px MajemaSkol_Exercise_bold", "#696969");
      yr3_filltext4.setTransform(300, 440);
      yr3_filltext4.textBaseline = "alphabetic";
      yr3_filltext4.name = "remove_ordbild";

      var yr3_filltext5: any = new createjs.Text("Skorpionen är inte särskilt             .", "55px MajemaSkol_Exercise_bold", "#696969");
      yr3_filltext5.setTransform(300, 510);
      yr3_filltext5.textBaseline = "alphabetic";
      yr3_filltext5.name = "remove_ordbild";

      var yr3_filltext6: any = new createjs.Text("Hammaren är det              jag använder mest.", "55px MajemaSkol_Exercise_bold", "#696969");
      yr3_filltext6.setTransform(300, 580);
      yr3_filltext6.textBaseline = "alphabetic";
      yr3_filltext6.name = "remove_ordbild";

      var yr3_filltext7: any = new createjs.Text("Katten hade lagt sina              på trappan utanför dörren.", "55px MajemaSkol_Exercise_bold", "#696969");
      yr3_filltext7.setTransform(300, 650);
      yr3_filltext7.textBaseline = "alphabetic";
      yr3_filltext7.name = "remove_ordbild";

      var yr3_filltext8: any = new createjs.Text("Man kan känna igen              på deras stora tänder.", "55px MajemaSkol_Exercise_bold", "#696969");
      yr3_filltext8.setTransform(300, 720);
      yr3_filltext8.textBaseline = "alphabetic";
      yr3_filltext8.name = "remove_ordbild";

      var yr3_bag_close = new createjs.Bitmap(bagclose);
      yr3_bag_close.setTransform(1490, 678, 0.5, 0.5);
      yr3_bag_close.cursor = 'pointer';
      yr3_bag_close.visible = true;
      yr3_bag_close.name = "remove_yr3_bag_close";

      var dstatus1, dstatus2, dstatus3, dstatus4, dstatus5, dstatus6, dstatus7, dstatus8: any = null;
      var statusarray = [dstatus1, dstatus2, dstatus3, dstatus4, dstatus5, dstatus6, dstatus7, dstatus8];
      var statusarrayresult = ["active", null];

      yr3_bag_close.addEventListener("click", function () {

        for (var j = 0; j < stage.children.length; j++) {
          if (stage.children[j].name == "remove_yr3_bag_close") {
            stage.removeChild(stage.children[j]);
            j = j - 1;
          }
        }

        statusarray[0] = null;
        statusarray[1] = null;
        statusarray[2] = null;
        statusarray[3] = null;
        statusarray[4] = null;
        statusarray[5] = null;
        statusarray[6] = null;
        statusarray[7] = null;

        var yr3_bag_closefinal = new createjs.Bitmap(bagclose);
        yr3_bag_closefinal.setTransform(1490, 678, 0.5, 0.5);
        yr3_bag_closefinal.visible = false;
        yr3_bag_closefinal.name = "remove_dragger";
        stage.addChild(yr3_bag_closefinal);

        yr3_bag_open.visible = true;

        var yr3_draggershuffle: any = [180, 250, 320, 390, 460, 530, 600, 670];
        let yr3_tweentimingarr: any = [0, 500, 1000, 1500, 2000, 2500, 3000, 3500];

        shuffle(yr3_draggershuffle, yr3_tweentimingarr);

        var yr3_dragger1: any = new createjs.Container();
        yr3_dragger1.cursor = 'pointer';
        yr3_dragger1.name = "remove_dragger";
        var dynamic_ques1: any = new createjs.Text("täcker", "55px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 50);
        dynamic_ques1.textBaseline = "alphabetic";
        var yr3_dynamic_ques1_pos = dynamic_ques1.getBounds();
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 20, yr3_dynamic_ques1_pos.width, 42);
        stage.enableMouseOver(20);
        yr3_dragger1.addChild(rect1, dynamic_ques1);
        yr3_dragger1.setTransform(1340, yr3_draggershuffle[0]);
        yr3_dragger1.alpha = 0;
        yr3_dragger1.on("pressmove", pressmovedragger);
        yr3_dragger1.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 0, 0, 0);
        });

        var yr3_dragger2: any = new createjs.Container();
        yr3_dragger2.cursor = 'pointer';
        yr3_dragger2.name = "remove_dragger";
        var dynamic_ques1: any = new createjs.Text("svingar", "55px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 50);
        dynamic_ques1.textBaseline = "alphabetic";
        var yr3_dynamic_ques2_pos = dynamic_ques1.getBounds();
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 20, yr3_dynamic_ques2_pos.width, 42);
        stage.enableMouseOver(20);
        yr3_dragger2.addChild(rect1, dynamic_ques1);
        yr3_dragger2.setTransform(1340, yr3_draggershuffle[1]);
        yr3_dragger2.alpha = 0;
        yr3_dragger2.on("pressmove", pressmovedragger);
        yr3_dragger2.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 1, 1, 1);
        });

        var yr3_dragger3: any = new createjs.Container();
        yr3_dragger3.cursor = 'pointer';
        yr3_dragger3.name = "remove_dragger";
        var dynamic_ques1: any = new createjs.Text("livnär", "55px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 50);
        dynamic_ques1.textBaseline = "alphabetic";
        var yr3_dynamic_ques3_pos = dynamic_ques1.getBounds();
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 20, yr3_dynamic_ques3_pos.width, 42);
        stage.enableMouseOver(20);
        yr3_dragger3.addChild(rect1, dynamic_ques1);
        yr3_dragger3.setTransform(1340, yr3_draggershuffle[2]);
        yr3_dragger3.alpha = 0;
        yr3_dragger3.on("pressmove", pressmovedragger);
        yr3_dragger3.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 2, 2, 2);
        });

        var yr3_dragger4: any = new createjs.Container();
        yr3_dragger4.cursor = 'pointer';
        yr3_dragger4.name = "remove_dragger";
        var dynamic_ques1: any = new createjs.Text("klibbiga", "55px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 50);
        dynamic_ques1.textBaseline = "alphabetic";
        var yr3_dynamic_ques4_pos = dynamic_ques1.getBounds();
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 20, yr3_dynamic_ques4_pos.width, 42);
        stage.enableMouseOver(20);
        yr3_dragger4.addChild(rect1, dynamic_ques1);
        yr3_dragger4.setTransform(1340, yr3_draggershuffle[3]);
        yr3_dragger4.alpha = 0;
        yr3_dragger4.on("pressmove", pressmovedragger);
        yr3_dragger4.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 3, 3, 3);
        });

        var yr3_dragger5: any = new createjs.Container();
        yr3_dragger5.cursor = 'pointer';
        yr3_dragger5.name = "remove_dragger";
        var dynamic_ques1: any = new createjs.Text("fredlig", "55px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 50);
        dynamic_ques1.textBaseline = "alphabetic";
        var yr3_dynamic_ques5_pos = dynamic_ques1.getBounds();
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 20, yr3_dynamic_ques5_pos.width, 42);
        stage.enableMouseOver(20);
        yr3_dragger5.addChild(rect1, dynamic_ques1);
        yr3_dragger5.setTransform(1340, yr3_draggershuffle[4]);
        yr3_dragger5.alpha = 0;
        yr3_dragger5.on("pressmove", pressmovedragger);
        yr3_dragger5.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 4, 4, 4);
        });

        var yr3_dragger6: any = new createjs.Container();
        yr3_dragger6.cursor = 'pointer';
        yr3_dragger6.name = "remove_dragger";
        var dynamic_ques1: any = new createjs.Text("verktyg", "55px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 50);
        dynamic_ques1.textBaseline = "alphabetic";
        var yr3_dynamic_ques6_pos = dynamic_ques1.getBounds();
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 20, yr3_dynamic_ques6_pos.width, 42);
        stage.enableMouseOver(20);
        yr3_dragger6.addChild(rect1, dynamic_ques1);
        yr3_dragger6.setTransform(1340, yr3_draggershuffle[5]);
        yr3_dragger6.alpha = 0;
        yr3_dragger6.on("pressmove", pressmovedragger);
        yr3_dragger6.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 5, 5, 5);
        });

        var yr3_dragger7: any = new createjs.Container();
        yr3_dragger7.cursor = 'pointer';
        yr3_dragger7.name = "remove_dragger";
        var dynamic_ques1: any = new createjs.Text("byten", "55px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 50);
        dynamic_ques1.textBaseline = "alphabetic";
        var yr3_dynamic_ques7_pos = dynamic_ques1.getBounds();
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 20, yr3_dynamic_ques7_pos.width, 42);
        stage.enableMouseOver(20);
        yr3_dragger7.addChild(rect1, dynamic_ques1);
        yr3_dragger7.setTransform(1340, yr3_draggershuffle[6]);
        yr3_dragger7.alpha = 0;
        yr3_dragger7.on("pressmove", pressmovedragger);
        yr3_dragger7.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 6, 6, 6);
        });

        var yr3_dragger8: any = new createjs.Container();
        yr3_dragger8.cursor = 'pointer';
        yr3_dragger8.name = "remove_dragger";
        var dynamic_ques1: any = new createjs.Text("gnagare", "55px MajemaSkol_Exercise_bold", "#696969");
        dynamic_ques1.setTransform(0, 50);
        dynamic_ques1.textBaseline = "alphabetic";
        var yr3_dynamic_ques8_pos = dynamic_ques1.getBounds();
        var rect1 = new createjs.Shape();
        rect1.graphics.setStrokeStyle(2).f("#FFF000").drawRect(0, 20, yr3_dynamic_ques8_pos.width, 42);
        stage.enableMouseOver(20);
        yr3_dragger8.addChild(rect1, dynamic_ques1);
        yr3_dragger8.setTransform(1340, yr3_draggershuffle[7]);
        yr3_dragger8.alpha = 0;
        yr3_dragger8.on("pressmove", pressmovedragger);
        yr3_dragger8.on("pressup", function (evt: any) {
          pressmovedraggerleave(evt, 7, 7, 7);
        });

        createjs.Tween.get(yr3_dragger1).wait(yr3_tweentimingarr[0]).to({ alpha: 0, x: 1540, y: 680 }, 500).to({ alpha: 1, x: 1340, y: yr3_draggershuffle[0], mouseEnabled: false }, 500);
        createjs.Tween.get(yr3_dragger2).wait(yr3_tweentimingarr[1]).to({ alpha: 0, x: 1540, y: 680 }, 500).to({ alpha: 1, x: 1340, y: yr3_draggershuffle[1], mouseEnabled: false }, 500);
        createjs.Tween.get(yr3_dragger3).wait(yr3_tweentimingarr[2]).to({ alpha: 0, x: 1540, y: 680 }, 500).to({ alpha: 1, x: 1340, y: yr3_draggershuffle[2], mouseEnabled: false }, 500);
        createjs.Tween.get(yr3_dragger4).wait(yr3_tweentimingarr[3]).to({ alpha: 0, x: 1540, y: 680 }, 500).to({ alpha: 1, x: 1340, y: yr3_draggershuffle[3], mouseEnabled: false }, 500);
        createjs.Tween.get(yr3_dragger5).wait(yr3_tweentimingarr[4]).to({ alpha: 0, x: 1540, y: 680 }, 500).to({ alpha: 1, x: 1340, y: yr3_draggershuffle[4], mouseEnabled: false }, 500);
        createjs.Tween.get(yr3_dragger6).wait(yr3_tweentimingarr[5]).to({ alpha: 0, x: 1540, y: 680 }, 500).to({ alpha: 1, x: 1340, y: yr3_draggershuffle[5], mouseEnabled: false }, 500);
        createjs.Tween.get(yr3_dragger7).wait(yr3_tweentimingarr[6]).to({ alpha: 0, x: 1540, y: 680 }, 500).to({ alpha: 1, x: 1340, y: yr3_draggershuffle[6], mouseEnabled: false }, 500);
        createjs.Tween.get(yr3_dragger8).wait(yr3_tweentimingarr[7]).to({ alpha: 0, x: 1540, y: 680 }, 500).to({ alpha: 1, x: 1340, y: yr3_draggershuffle[7], mouseEnabled: false }, 500);

        createjs.Tween.get(yr3_bag_closefinal).wait(4500).to({ visible: true, alpha: 0.5 }, 0);
        createjs.Tween.get(yr3_bag_open).wait(4500).call(function () {

          yr3_dragger1.mouseEnabled = true;
          yr3_dragger2.mouseEnabled = true;
          yr3_dragger3.mouseEnabled = true;
          yr3_dragger4.mouseEnabled = true;
          yr3_dragger5.mouseEnabled = true;
          yr3_dragger6.mouseEnabled = true;
          yr3_dragger7.mouseEnabled = true;
          yr3_dragger8.mouseEnabled = true;

        }).to({ visible: false }, 0);

        stage.addChild(yr3_dragger1, yr3_dragger2, yr3_dragger3, yr3_dragger4, yr3_dragger5, yr3_dragger6, yr3_dragger7, yr3_dragger8);

        var yr3_destinationarr = [yr3_destination1, yr3_destination2, yr3_destination3, yr3_destination4, yr3_destination5, yr3_destination6, yr3_destination7, yr3_destination8];
        var yr3_draggerarr = [yr3_dragger1, yr3_dragger2, yr3_dragger3, yr3_dragger4, yr3_dragger5, yr3_dragger6, yr3_dragger7, yr3_dragger8];
        var yr3_settrasformarrayx: any = [1340, 1340, 1340, 1340, 1340, 1340, 1340, 1340];
        var yr3_settrasformarrayy: any = [yr3_draggershuffle[0], yr3_draggershuffle[1], yr3_draggershuffle[2], yr3_draggershuffle[3], yr3_draggershuffle[4], yr3_draggershuffle[5], yr3_draggershuffle[6], yr3_draggershuffle[7]];

        var yr3_finalsentarr = ["Färgen vi målar med täcker bra.",
          "Aporna svingar sig fram bland grenar och lianer.",
          "Min lillebror livnär sig på välling.",
          "De nymålade stolarna var alldeles klibbiga.",
          "Skorpionen är inte särskilt fredlig.",
          "Hammaren är det verktyg jag använder mest.",
          "Katten hade lagt sina byten på trappan utanför dörren.",
          "Man kan känna igen gnagare på deras stora tänder."
        ];


        var yr3_quessent = [yr3_filltext1, yr3_filltext2, yr3_filltext3, yr3_filltext4, yr3_filltext5, yr3_filltext6, yr3_filltext7, yr3_filltext8];

        var yr3_finalsentarr_Y = [230, 300, 370, 440, 510, 580, 650, 720];

        function pressmovedragger(evt: any) {
          evt.currentTarget.x = evt.stageX - 50;
          evt.currentTarget.y = evt.stageY - 50;

        }

        function pressmovedraggerleave(evt: any, i: any, j: any, f: any) {

          if (intersect(yr3_draggerarr[j], yr3_destinationarr[i]) && statusarray[f] != "active") {
            var yr3_draggerbounds = yr3_draggerarr[j].getBounds();
            yr3_draggerarr[j].x = yr3_destinationarr[i].x + (150 - yr3_draggerbounds.width) / 2;
            yr3_draggerarr[j].y = yr3_destinationarr[i].y - 20;
            statusarray[f] = "active";
            createjs.Tween.get(yr3_destinationarr[i]).wait(500).to({ alpha: 0 }, 500);
            createjs.Tween.get(yr3_draggerarr[j].children[0]).wait(1000).to({ alpha: 0 }, 500);
            createjs.Tween.get(yr3_draggerarr[j]).wait(1500).to({ alpha: 0 }, 500);
            createjs.Tween.get(yr3_quessent[j]).wait(1500).to({ alpha: 0 }, 500);


            var yr3_finalsent: any = new createjs.Text(yr3_finalsentarr[j], "55px MajemaSkol_Exercise_bold", "#696969");
            yr3_finalsent.setTransform(300, yr3_finalsentarr_Y[j]);
            yr3_finalsent.textBaseline = "alphabetic";
            yr3_finalsent.name = "remove_ordbild";
            yr3_finalsent.alpha = 0;

            stage.addChild(yr3_finalsent);

            createjs.Tween.get(yr3_finalsent).wait(2000).to({ alpha: 1 }, 500);

            if (statusarray[0] == statusarrayresult[0] && statusarray[1] == statusarrayresult[0] &&
              statusarray[2] == statusarrayresult[0] && statusarray[3] == statusarrayresult[0] &&
              statusarray[4] == statusarrayresult[0] && statusarray[5] == statusarrayresult[0] &&
              statusarray[6] == statusarrayresult[0] && statusarray[7] == statusarrayresult[0]) {
              cheersound[cheersoundrandomNum].play();
            }

            evt.currentTarget.mouseEnabled = false;

          }
          else {
            createjs.Tween.get(yr3_draggerarr[j])
              .to({ x: yr3_settrasformarrayx[j], y: yr3_settrasformarrayy[j] }, 500);

          }
        }
      });

      stage.addChild(yr3_filltext1, yr3_filltext2, yr3_filltext3, yr3_filltext4, yr3_filltext5, yr3_filltext6, yr3_filltext7, yr3_filltext8,
        yr3_destination1, yr3_destination2, yr3_destination3, yr3_destination4, yr3_destination5, yr3_destination6, yr3_destination7, yr3_destination8, yr3_bag_close, yr3_bag_open);

    }

    function intersect(obj1, obj2) {
      var objBounds1 = obj1.getBounds().clone();
      var objBounds2 = obj2.getBounds().clone();

      var pt = obj1.globalToLocal(objBounds2.x, objBounds2.y);

      var h1 = -(objBounds1.height / 2 + objBounds2.height);
      var h2 = objBounds2.width / 2;
      var w1 = -(objBounds1.width / 2 + objBounds2.width);
      var w2 = objBounds2.width / 2;


      if (pt.x > w2 || pt.x < w1) return false;
      if (pt.y > h2 || pt.y < h1) return false;

      return true;

    }


    stage.addChild(yr3_tagimage1, yr3_bitmap, yr3_heading, yr3_drake, yr3_option_container, yr3_opt_circle1, yr3_opt_circle2);
    stage.enableMouseOver();
    createjs.Ticker.reset();
    createjs.Ticker.framerate = 60;
    createjs.Ticker.addEventListener("tick", this.stage);
    createjs.Ticker.addEventListener("tick", createjs.Tween);
    createjs.Ticker.timingMode = createjs.Ticker.RAF;
  }

  onCloseCancel() {
    createjs.Ticker.reset();
    createjs.Touch.disable(this.stage);
    createjs.Tween.removeAllTweens();
    this.stage.enableMouseOver(0);
    this.stage.clear();
    this.thisDialogRef.close('Cancel');
  }
}

